import { Grid } from '@mui/system';
import { CustomContainer } from 'components/CustomContainer';
import { KeyboardShortcutItemProps } from './ShortcutHelper.props';
import { useKeyboardShortcutItemStyles } from './ShortcutHelper.styles';

const KeyboardShortcutItem = ({ action, combination }: KeyboardShortcutItemProps) => {
  const classes = useKeyboardShortcutItemStyles();

  return (
    <CustomContainer direction="column" rowSpacing={0.5}>
      <Grid className={classes.action} size={{ xs: 12 }}>
        <p>{action}</p>
      </Grid>

      <Grid className={classes.combination} size={{ xs: 12 }}>
        <p>{combination}</p>
      </Grid>
    </CustomContainer>
  );
};

export default KeyboardShortcutItem;
